import $ from 'jquery';
import _ from 'underscore';
import Numeral from 'numeral';
import Cache from 'root/cache';
import Constants from 'root/constants';
import Modals from 'root/modals';
import UI from 'root/ui';
import Util from 'root/module/util';
import Form from 'root/module/form';
import View from 'view/base';
import View_Menu from 'page/account/menu';
import View_Invoice_Row from 'view/invoice/invoice_row';

export default View.extend({
    tagName: 'section',

    page: 1,
    limit: 10,

    views: {
        menu: {},
        invoices: {},
    },

    events: {
        'click .payment-method-change' : 'onChangePaymentMethod',
        'click .change-plan'           : 'onChangePlan',
        'click .workspace-delete'      : 'onDeleteWorkspace',
        'click .billing-email-edit'    : 'onEditBillingEmail',
        'click .billing-address-edit'  : 'onEditBillingAddress',
        'click .cancel-plan-change'    : 'onCancelPlanChange',
        'submit .billing-email-form'   : 'onSubmitBillingEmail',
        'submit .address-form'         : 'onSubmitBillingAddress',
        'click .previous'              : 'prevPage',
        'click .next'                  : 'nextPage'
    },

    dom_handlers: {
        onChangePaymentMethod: function(e) {
            e.preventDefault();
            Modals.changePaymentMethod();
        },

        onChangePlan: function() {
            Modals.choosePlan();
        },

        onDeleteWorkspace: function(e) {
            Modals.closeAccount();
        },

        onEditBillingEmail: function(e) {
            e.preventDefault();

            this.$el.find('.billing-email-form').show();
            this.$el.find('.billing-email').hide();

            this.$el.find('input[name="billing_email"]').val(Cache.account.get('billing_email')).focus();
        },

        onEditBillingAddress: function(e) {
            e.preventDefault();

            this.$el.find('.address-form').show();
            this.$el.find('.address').hide();

            this.$el.find('textarea[name="address"]').val(Cache.account.get('address')).focus();
        },

        onSubmitBillingEmail: function(e) {
            var billing_email = Form.getData(this.$el.find('.billing-email-form'), 'billing_email');

            this.$el.find('.billing-email-form').hide();
            this.$el.find('.billing-email')
                .text(billing_email || '-')
                .show();

            Cache.app.request({
                action: 'account/saveDetails',
                data: {
                    billing_email: billing_email
                },
                success: () => {
                    Cache.account.set('billing_email', billing_email);
                    UI.success('Billing email updated');
                }
            });
        },

        onSubmitBillingAddress: function(e) {
            var address = Form.getData(this.$el.find('.address-form'), 'address');

            this.$el.find('.address-form').hide();
            this.$el.find('.address')
                .html((Util.nl2br(Util.htmlEntities(address)) || '-'))
                .show();

            Cache.app.request({
                action: 'account/saveDetails',
                data: {
                    address: address
                },
                success: () => {
                    Cache.account.set('address', address);
                    UI.success('Billing address updated');
                }
            });
        },

        onCancelPlanChange: function(e) {
            e.preventDefault();
            Modals.cancelPlanChange();
        },

        prevPage: function(e) {
            if (Cache.invoice.length === 0) {
                return;
            }

            this.page--;
            this.page = Math.max(this.page, 1);
            this.goToPage();
        },

        nextPage: function(e) {
            if (Cache.invoice.length === 0) {
                return;
            }

            var total_page = Math.ceil(Cache.invoice.length / this.limit);

            this.page++;
            this.page = Math.min(this.page, total_page);
            this.goToPage();
        }
    },

    initialize: function() {
        this.views.menu = new View_Menu();

        this.listenTo(Cache.account, 'change:credit_card_digit', this.updateCreditCardNumber);
        this.listenTo(Cache.account, 'change:plan_provision',    this.updatePlanProvision);
    },

    onPageReady: function() {
        Cache.app.request({
            action: 'invoice/getData',
            context: this,
            success: function(response) {
                this.$el.find('.table-loader').remove();
                Cache.invoice.reset(response);

                Cache.invoice.each(function(model) {
                    this.views.invoices['_' + model.id] = new View_Invoice_Row({model: model});
                    this.views.invoices['_' + model.id].render().$el.insertAfter(this.$el.find('table tr:last'));
                }, this);

                if (Cache.invoice.length) {
                    this.goToPage();
                } else {
                    $('<div>').html('<div class="divider-large"></div><p class="text-align-center">No invoices found in your account</p>').insertAfter(this.$el.find('table:first'));
                }
            }
        });
    },

    goToPage: function() {
        var total_page = Math.ceil(Cache.invoice.length / this.limit);
        this.$el.find('.current-page b').text(this.page + ' of ' + total_page);

        var start = (this.page - 1) * this.limit;
        var stop  = start + this.limit - 1;

        _.each(this.views.invoices, function(view) {
            view.$el.hide();
        });

        Cache.invoice.each(function(model, index) {
            if (index >= start && index <= stop) {
                this.views.invoices['_' + model.id].$el.show();
            }
        }, this);
    },

    updateCreditCardNumber: function() {
        this.$el.find('.cc-digit').text(Cache.account.get('credit_card_digit'));
    },

    updatePlanProvision: function() {
        if (!Cache.account.get('plan_provision')) {
            this.$el.find('.plan-provision-row').remove();
        }
    },

    renderUsage: function() {
        var num_archived_projects = Cache.project.where({is_archived: true}).length;
        var num_active_projects   = Cache.project.length - num_archived_projects;
        var num_active_users      = Cache.workspace_member.where({is_disabled: false}).length;
        var account_usage         = Cache.account.getUsage();
        var num_responses         = account_usage.feedback + account_usage.survey_response;

        var html =

        // projects
        (!Cache.account.hasProjectLimit() ? '' :
        '<div>' +
            '<div>' + num_active_projects + ' / ' + (Cache.account.get('appsumo') ? 'Unlimited' : Cache.account.getProjectLimit()) + ' projects</div>' +
            '<div class="meteor-shiny"><div><span style="width:' + (num_active_projects / Cache.account.getProjectLimit() * 100) + '%;"></span></div></div>' +
        '</div>') +

        // users
        (!Cache.account.hasUserLimit() ? '' :
        '<div>' +
            '<div class="flex-between">' + num_active_users + ' / ' + (Cache.account.get('appsumo') ? 'Unlimited seats' : Cache.account.getUserLimit() + ' seat' + (Cache.account.getUserLimit() === 1 ? '' : 's')) + '</div>' +
            '<div class="meteor-shiny"><div><span style="width:' + (num_active_users / Cache.account.getUserLimit() * 100) + '%;"></span></div></div>' +
        '</div>') +

        // responses
        (Cache.account.isPricing2025() && Cache.account.hasResponseLimit() ?
        '<div>' +
            '<div>' + Numeral(num_responses).format('0,0') + ' / ' + Numeral(Cache.account.getResponseLimit()).format('0,0') +
            ' feedback' + (Cache.account.isPricing2025() ? '' : ' & survey responses') + ' (monthly)</div>' +
            '<div class="meteor-shiny"><div><span style="width:' + (num_responses / Cache.account.getResponseLimit() * 100) + '%;"></span></div></div>' +
        '</div>' : '') +

        (Cache.account.hasFeature('full_session_recording') && Cache.account.getSessionLimit() > 0 ?
        '<div>' +
            '<div>' + Numeral(account_usage.session_recording).format('0,0') + ' / ' + Numeral(Cache.account.getSessionLimit()).format('0,0') + ' full session replays (monthly)</div>' +
            '<div class="meteor-shiny"><div><span style="width:' + (account_usage.session_recording / Cache.account.getSessionLimit() * 100) + '%;"></span></div></div>' +
        '</div>' : '');

        this.$el.find('.region-usage').html(html);
    },

    render: function() {
        UI.setPageTitle('Billing');

        var account_sceduled = Cache.account.clone();

        if (Cache.account.get('plan_provision')) {
            account_sceduled.set({
                plan: Cache.account.get('plan_provision').plan,
                extra_user: Cache.account.get('plan_provision').extra_user,
                session_limit: Cache.account.get('plan_provision').session_limit,
                response_limit: Cache.account.get('plan_provision').response_limit
            });
        }

        var trial_status = '';
        if (Cache.account.get('is_trial')) {
            var days_remaining = Util.daysDiff(Cache.account.get('trial_expiry_date'));

            if (days_remaining < 0) {
                trial_status += 'Downgrade to Free plan in ' + ((days_remaining * -1) + 1) + ' day' + (days_remaining === 1 ? '' : 's');
            } else {
                trial_status += 'Dowbgrade to Free plan today';
            }
        } else if (Cache.account.get('is_expired')) {
            trial_status = 'Expired';
        }

        var billing_cycle = Cache.account.getBillingCycle();

        var content =
        '<main class="xlarge">' +
            '<div>Manage your billing information and invoices</div>' +
            '<div class="divider-24"></div>' +

            '<div class="box box-nopadding">' +
                '<div>' +
                    '<div class="grid-4-8 padding-32">' +
                        '<div><b>Account ID:</b></div>' +
                        '<div>' +
                            Util.padLeft(Cache.account.id) +
                            '<div class="text-info text-small margin-top-16"><a href="https://userback.io/terms" class="primary" target="policy">Terms</a> and <a href="https://userback.io/privacy" class="primary" target="policy">Privacy Policy</a> accepted on:<span class="margin-left-8 font-weight-medium">' + Util.moment(Cache.account.get('join_time')) + '</span></div>' +
                        '</div>' +
                    '</div>' +

                    '<hr class="xsmall">' +

                    '<div class="grid-4-8 padding-32">' +
                        '<div><b>Account Plan:</b></div>' +
                        '<div class="grid-8-4">' +
                            '<div>' +
                                // Plan name
                                '<div>' +
                                    '<b>' + (Cache.account.get('appsumo') ? 'LTD' : Cache.account.getPlanName()) + '</b>' +
                                    (billing_cycle ? '<span class="badge-secondary-invert badge-round margin-left-8 font-weight-medium">' + billing_cycle + '</span>' : '') +
                                    (trial_status  ? '<span class="badge-primary-invert badge-round margin-left-8 font-weight-medium tooltip" data-title="' + trial_status + '">Trial</span>' : '') +
                                '</div>' +

                                // Add-on
                                (Cache.account.isPricing2025() && Cache.account.hasAddon('portal') ?
                                '<div class="margin-top-8">' +
                                    '<b>Add-on:</b> Ideas Portal' +
                                '</div>' : '') +

                                // Account usage
                                (Cache.account.get('is_trial') ? '' :
                                '<div class="divider-12"></div>' +
                                '<div class="region-usage grid-gap-16"></div>' +
                                ((Cache.account.hasFeature('full_session_recording') || Cache.account.hasResponseLimit()) && Cache.account.get('billing_day') ?
                                '<div class="text-info text-small margin-top-16">Monthly usage resets on:<span class="cap margin-left-8 font-weight-medium">' + Cache.account.getUsageResetDate() + '</span></div>' : '')) +

                                // Plan provision
                                (Cache.account.get('plan_provision') ?
                                '<div class="plan-provision-row solid-line-top padding-top-20 margin-top-12">' +
                                    // Plan name
                                    '<b>' + Cache.account.getPlanName(Cache.account.get('plan_provision').plan) + '</b>' +
                                    '<span class="badge-secondary-invert badge-round margin-left-8 font-weight-medium">' + (Cache.account.get('plan_provision').billing_interval === Constants.MONTHLY ? 'Monthly' : 'Annual') + '</span>' +

                                    (account_sceduled.isFreePlan() ? '' :
                                    // Add-on
                                    (Cache.account.get('plan_provision').addon_remove.indexOf('portal') !== -1 || Cache.account.get('plan_provision').addon_add.indexOf('portal') !== -1 ?
                                    '<div class="margin-top-8">' +
                                        '<b>Add-on:</b> ' + (Cache.account.get('plan_provision').addon_remove.indexOf('portal') !== -1 ? '-' : 'Ideas Portal') +
                                    '</div>' : '' ) +

                                    // Seats
                                    (Cache.account.hasUserLimit() ?
                                    '<div class="margin-top-8">' +
                                        '<b>Seats:</b> ' + account_sceduled.getUserLimit() +
                                    '</div>' : '')) +

                                    // Session
                                    (Cache.account.hasFeature('full_session_recording') || account_sceduled.hasFeature('full_session_recording') ?
                                    '<div class="margin-top-8">' +
                                        '<b>Sessions:</b> ' + Numeral(Cache.account.get('plan_provision').session_limit).format('0,0') +
                                    '</div>' : '') +

                                    // Cancel link
                                    '<div class="margin-top-12 notification-attention">' +
                                        '<span class="icon"><i class="fas fa-info-circle"></i></span>' +
                                        '<span>The change is scheduled for <span class="font-weight-medium">' + Util.moment(Cache.account.get('plan_provision').time, false, false, false) + '</span><a href="#" class="cancel-plan-change text-info no-underline tooltip margin-left-24 font-weight-medium" data-title="Cancel plan change request"><i class="fa-solid fa-circle-xmark"></i> Cancel</a></span>' +
                                    '</div>' +
                                '</div>' : '' ) +
                            '</div>' +
                            '<div class="text-align-right">' +
                                '<button class="primary small change-plan">' + (Cache.account.get('is_trial') || Cache.account.get('is_expired') ? 'Upgrade' : 'Manage Subscription') + '</button>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +

                    (Cache.account.get('credit') ?
                    '<hr class="xsmall">' +

                    '<div class="grid-4-8 padding-32">' +
                        '<div><b>Account Credit:</b></div>' +
                        '<div>$' + (Cache.account.get('credit') / 100).toFixed(2) + '</div>' +
                    '</div>' : '') +

                    '<hr class="xsmall">' +

                    '<div class="grid-4-8 padding-32">' +
                        '<div><b>Billing Email:</b></div>' +
                        '<div class="grid-9-3">' +
                            '<div>' +
                                '<span class="billing-email">' + (Cache.account.escape('billing_email') || '-') + '</span>' +
                                '<form class="billing-email-form hidden">' +
                                    '<input type="email" class="solid medium" name="billing_email">' +
                                    '<button type="submit" class="primary small margin-top-8">Save</button>' +
                                '</form>' +
                            '</div>' +
                            '<div class="text-align-right">' +
                                '<a href="#" class="billing-email-edit primary text-medium font-weight-medium">' + (Cache.account.get('billing_email') ? 'Update' : 'Add') + '</a>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +

                    '<hr class="xsmall">' +

                    '<div class="grid-4-8 padding-32">' +
                        '<div><b>Billing Address:</b></div>' +
                        '<div class="grid-9-3">' +
                            '<div>' +
                                '<span class="address">' + (Util.nl2br(Cache.account.escape('address')) || '-') + '</span>' +
                                '<form class="address-form hidden">' +
                                    '<textarea name="address" class="solid compact" rows="5"></textarea>' +
                                    '<button type="submit" class="primary small margin-top-8">Save</button>' +
                                '</form>' +
                            '</div>' +
                            '<div class="text-align-right">' +
                                '<a href="#" class="billing-address-edit primary text-medium font-weight-medium">' + (Cache.account.get('address') ? 'Update' : 'Add') + '</a>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +

                    '<hr class="xsmall">' +

                    '<div class="grid-4-8 padding-32">' +
                        '<div><b>Payment Method:</b></div>' +
                        '<div>' +
                            (Cache.account.get('credit_card_digit') ?
                            '<i class="fad fa-credit-card"></i> <i class="far fa-ellipsis-h"></i> <i class="far fa-ellipsis-h"></i> <i class="far fa-ellipsis-h"></i> ' +
                            '<span class="cc-digit">' + Cache.account.get('credit_card_digit') + '</span>' : '-') +

                            (Cache.account.get('credit_card_digit') ?
                            '<a href="#" class="payment-method-change primary text-medium font-weight-medium float-right">Update</a>' : '') +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</div>' +

            '<div class="divider-24"></div>' +

            '<h2><b>Invoices</b></h2>' +
            '<div class="box">' +
                '<div class="overflow-auto">' +
                    '<table cellpadding="0" cellspacing="0">' +
                        '<tr>' +
                            '<th>Invoice Number</th>' +
                            //'<th>Description</th>' +
                            '<th>Invoice Date</th>' +
                            '<th>Payment Date</th>' +
                            '<th class="text-align-right">Total Amount</th>' +
                            '<th class="text-align-right">Credit</th>' +
                            '<th class="text-align-right">Status</th>' +
                            '<th></th>' +
                        '</tr>' +
                    '</table>' +
                '</div>' +
                '<div class="text-align-center">' +
                    '<div class="button-group margin-top-20" data-autohighlight="false">' +
                        '<button class="text small inline previous tooltip" data-title="Previous"><i class="far fa-angle-left"></i></button>' +
                        '<button class="small inline current-page"><b>1 of 1</b></button>' +
                        '<button class="text small inline next tooltip" data-title="Next"><i class="far fa-angle-right"></i></button>' +
                    '</div>' +
                '</div>' +
                '<div class="table-loader loader loader-primary text-align-center" style="min-height:100px;"></div>' +
            '</div>' +

            (Cache.app.isOwner() ?
            '<div class="divider-24"></div>' +

            '<h2 class="margin-bottom-20"><b>Danger Zone</b></h2>' +
            '<div class="box grid-4-8 grid-none-mobile padding-48 padding-20-phone">' +
                '<div>' +
                    '<h3>Delete workspace</h3>' +
                    '<div class="text-info text-medium">No longer need the workspace?</div>' +
                '</div>' +
                '<div class="text-align-right">' +
                    '<button type="button" class="workspace-delete secondary medium">Delete Workspace</button>' +
                '</div>' +
            '</div>' : '') +

            '</main>';

        this.$el.html(content);

        this.views.menu.render().$el.prependTo(this.$el.find('main'));

        this.renderUsage();

        return this;
    }
});